import React, { useEffect, useState } from "react";
import { backend_url } from "../App";
import ReactPaginate from "react-paginate";
import "./CSS/Customers.css";

const Customers = () => {
  const [customers, setCustomers] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const customersPerPage = 8;

  useEffect(() => {
    fetchCustomers();
  }, []);

  const fetchCustomers = async () => {
    try {
      const response = await fetch(`${backend_url}/admin/get-all-users`);
      const data = await response.json();
      if (data.success && Array.isArray(data.users)) {
        setCustomers(data.users);
      } else {
        setCustomers([]);
      }
    } catch (error) {
      setCustomers([]);
    }
  };

  const searchedUsers = customers.filter((user) =>
    (user.name || "").toLowerCase().includes(searchQuery.toLowerCase()) ||
    (user.email || "").toLowerCase().includes(searchQuery.toLowerCase()) ||
    (user.phoneNumber || "").toString().includes(searchQuery)
  );

  const offset = currentPage * customersPerPage;
  const currentUsers = searchedUsers.slice(offset, offset + customersPerPage);
  const pageCount = Math.ceil(searchedUsers.length / customersPerPage);

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };

  const formatAddress = (user) => {
    const parts = [user.address, user.city, user.pincode, user.state, user.country]
      .filter((v) => v && v !== "N/A" && v !== "null");
    return parts.length > 0 ? parts.join(", ") : "—";
  };

  const getInitial = (name) =>
    name && name !== "N/A" ? name.charAt(0).toUpperCase() : "?";

  return (
    <div className="customers-page">

      {/* ── Header ── */}
      <div className="customers-header">
        <div className="customers-title-group">
          <h2 className="customers-title">
            👥 Customer Details
          </h2>
          <span className="customers-count-badge">{customers.length} customers</span>
        </div>

        <div className="customers-search-wrap">
          <span className="customers-search-icon">🔍</span>
          <input
            type="text"
            placeholder="Search by name, email or phone..."
            value={searchQuery}
            onChange={(e) => { setSearchQuery(e.target.value); setCurrentPage(0); }}
          />
        </div>
      </div>

      {/* ── Stat ── */}
      <div className="customers-stat">
        <div className="customers-stat-icon">👤</div>
        <div>
          <div className="customers-stat-label">Total Customers</div>
          <div className="customers-stat-value">{customers.length}</div>
        </div>
      </div>

      {/* ── Table ── */}
      <div className="customers-table-wrapper">
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>Customer</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Address</th>
            </tr>
          </thead>
          <tbody>
            {currentUsers.length > 0 ? (
              currentUsers.map((user, idx) => (
                <tr key={user._id || user.id}>
                  <td>
                    <div className="cust-serial">{offset + idx + 1}</div>
                  </td>
                  <td>
                    <div className="cust-name-cell">
                      <div className="cust-avatar">{getInitial(user.name)}</div>
                      <span className="cust-name">{user.name || "—"}</span>
                    </div>
                  </td>
                  <td className="cust-email">{user.email || "—"}</td>
                  <td className="cust-phone">{user.phoneNumber || "—"}</td>
                  <td className="cust-address">{formatAddress(user)}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5">
                  <div className="cust-empty">
                    <div className="cust-empty-icon">🙍</div>
                    No customers found
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* ── Pagination ── */}
      {pageCount > 1 && (
        <div className="customers-pagination-wrapper">
          <ReactPaginate
            previousLabel="← Prev"
            nextLabel="Next →"
            breakLabel="..."
            pageCount={pageCount}
            onPageChange={handlePageChange}
            containerClassName="pagination"
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            previousLinkClassName="page-link"
            nextClassName="page-item"
            nextLinkClassName="page-link"
            breakClassName="page-item"
            breakLinkClassName="page-link"
            activeClassName="active"
            disabledClassName="disabled"
          />
        </div>
      )}
    </div>
  );
};

export default Customers;
